import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { DireccionEstadoList } from "./list/list";
import { EstadoEdit } from "./edit/edit";

export class DireccionEstadoCatalogo extends React.Component<{match: match<{}>}> {
    render() {
       const path = this.props.match.url;
        return (
            <div>
                <Route exact path={path}  component={DireccionEstadoList} />
                <Route path={path + "/:id"}  component={EstadoEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/DireccionEstado/index.tsx